import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: "Rent-O-Tech",
    tagline: "Laptop and desktop rental in Delhi NCR",
    description: "Rent-O-Tech rents business laptops and desktops, runs IT hardware AMC and sells refurbished laptops to companies across Delhi NCR. Get a free quote.",
    url: 'https://rentotech.com',
    ogImage: 'https://rent-o-tech.cdn.modulify.website/images/rent-o-tech-share.jpg',
    phone: {
        display: "+91 87006 34443",
        href: 'tel:+918700634443',
        schema: '+91-8700634443'
    },
    email: 'sales@rentotech.com',
    region: "Delhi NCR",
    lastUpdated: '2026-11-01'
}
